import { QUALITY_MODE_NUMBER_MAP } from "./constants";
import { QualityMode } from "./room/participant/media/types";
import { BackgroundSettings } from "./types";
import { getStoredAudioVideoSettings } from "./utils";

export const MAX_ROOM_DURATION_SECONDS = 60 * 60 * 3; // 3 hours
export const DEFAULT_DEVICE_ID = "default";

/**
 * Returns a number greater than 0 if a is greater than b, a number less than 0
 * if b is greater than a, or 0 if they are equal.
 */
export function compareQualityMode(a: QualityMode, b: QualityMode) {
  return QUALITY_MODE_NUMBER_MAP[a] - QUALITY_MODE_NUMBER_MAP[b];
}

export function getStoredBackgroundSettings(): BackgroundSettings {
  const { backgroundType, backgroundIndex } = getStoredAudioVideoSettings();
  return { backgroundType, backgroundIndex };
}
